module.exports = "/_next/static/media/9df70c8ccfc5b2734c8375fe760a4530.svg";